import React from 'react';
import { Noticebar, useTestId } from '@cmctechnology/webinvest-design-system';
import { Trans, useTranslation } from 'react-i18next';
import { getMaintenanceFormattedTime } from '../configs/maintenanceConfig';
import styled from 'styled-components';
import { useMaintenance } from '../hocs/MaintenanceContext';

interface IMaintenanceBannerProps extends React.PropsWithChildren {}

const Content = styled.div`
  position: relative;
  overflow-x: clip;
`;

export const MaintenanceBanner: React.FC<IMaintenanceBannerProps> = ({ children, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'MaintenanceBanner');
  const { t } = useTranslation();

  const { showMaintenanceBanner } = useMaintenance();
  const { maintenanceDay, maintenanceEndTime, maintenanceStartTime } = getMaintenanceFormattedTime();

  if (!showMaintenanceBanner) {
    return <>{children}</>;
  }

  return (
    <>
      <Noticebar variant='info' closable {...generateTestId()}>
        <Trans t={t}>
          Scheduled Maintenance: We will be performing scheduled maintenance on {{ maintenanceDay } as any}, between {{ maintenanceStartTime } as any} and{' '}
          {{ maintenanceEndTime } as any}. During this time, our trading platform and mobile app will be unavailable. We apologise for any inconvenience caused.
        </Trans>
      </Noticebar>
      <Content {...generateTestId('Content')}>{children}</Content>
    </>
  );
};
